<template lang="">
    <div class="product__item-grid">
        <ssl-plan v-for="sslPlan in sslPlans" :key="sslPlan.name" :productPlan="sslPlan" :domain="domain" />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SslPlan from './SslPlan.vue';

export default {
    components: {
        SslPlan
    },
    props: {
        domain: Object
    },
    computed: {
        ...mapGetters({
            sslPlans: 'products/sslPlans'
        })
    }
};
</script>
